
import { Message } from 'element-ui';
/**
 * 获取上传的图片key
 * @returns 
 */
export function getPicKeyName(){
    let str = 'hmpc'
    let range = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z','0','1','2','3','4','5','6','7','8','9']
    for(let i = 0;i < 5;i++){
        let r = Math.random()*35
        str += range[parseInt(r)]
    }
    let m = JSON.parse(localStorage.getItem('managerInfo'))
    if(m){
        str += m.id
    }
    return str + new Date().getTime()+'.png';
}

/**
 * 
 * @param {*} list 
 * @param {*} v 
 * @param {*} name 
 * @returns 
 */
export function getLabel(list,v,name = 'label',value="value"){
	if(!v || !list){
		return ''
	}
	for (let i = 0; i < list.length; i++) {
		if (list[i][value] == v) {
		  return list[i][name];
		}
	  }
	  return v;
  }


  export function getNameByValue(types , value){
    for (let i = 0; i < types.length; i++) {
      if (types[i].value == value) {
        return types[i].name;
      }
    }
    return ''
  }

/**
 * 计算两个经纬度之间的距离
 * @param lat1
 * @param lng1
 * @param lat2
 * @param lng2
 * @returns distance 
 */
 export function getDistance(lat1, lng1, lat2, lng2) {
	var radLat1 = rad(lat1);
	var radLat2 = rad(lat2);
	var a = radLat1 - radLat2;
	var b = rad(lng1) - rad(lng2);
	var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math
		.pow(Math.sin(b / 2), 2)));
	s = s * 6378.137; // EARTH_RADIUS;
	s = Math.round(s * 10000) / 10000; //输出为公里
	var distance = s;
	if (s !== s) {
		return ''
	}
	var distance_str = '';
	if (parseInt(distance) >= 1) {
		distance_str = distance >= 100 ? '>100km' : distance.toFixed(1) + 'km';
	} else {
		distance_str = (distance * 1000).toFixed(0) + 'm';
	}
	return distance_str || "";
}

function rad(d) {
	return (d * Math.PI) / 180.0;
}


/**
 * 防抖
 * @param func 
 * @param wait 
 * @returns 
 */
 export function debounce(func, wait) {
    var timeout, result;
    return function () {
        var context = this, args = arguments;
        if (timeout)  clearTimeout(timeout);
       
            timeout = setTimeout(function() {
                result = func.apply(context, args)
            }, wait);
        
        return result;
    }
}



 
/**
 * 节流
 * @param func 
 * @param wait 
 * @returns 
 */
export function throttle(func, delay) {
	var prev = Date.now()
	return function () {
		var context = this;
		var args = arguments;
		var now = Date.now();
		if (now - prev >= delay) {
			func.apply(context, args);
			prev = Date.now();
		}
	}
}



export async function copyText(txt){
	await navigator.clipboard.writeText(txt);  
	Message.success('复制成功')
}




/**计算年龄
 * @param {Object} birthDateString
 */
 export function calculateAge(birthDateString) {
	if(birthDateString == ''){
		return '';
	}
    // 1. 解析生日字符串 (YYYYMMDD)
    const year = parseInt(birthDateString.substring(0, 4), 10);
    const month = parseInt(birthDateString.substring(4, 6), 10) - 1; // 月份从 0 开始 (0-11)
    const day = parseInt(birthDateString.substring(6, 8), 10);

    const birthDate = new Date(year, month, day);
    
    // 检查日期是否有效
    if (isNaN(birthDate.getTime())) {
        return "";
    }

    // 2. 获取当前日期
    const today = new Date();

    // 3. 初步计算年龄 (年份差)
    let age = today.getFullYear() - birthDate.getFullYear();

    // 4. 校正年龄 (检查今年是否已过生日)
    // 获取今年的生日日期
    const currentYearBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());

    // 如果今天还没到今年的生日，年龄减 1
    if (today < currentYearBirthday) {
        age--;
    }

    return age;
}